import { styled } from 'baseui'
import type { Theme } from 'baseui'
import type { StyleObject } from 'styletron-standard'

export const TileGrid = styled('div', {
  width: '100%',
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '0.625rem',
})

const tileStyle = ($theme: Theme): StyleObject => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '0.5rem',
  minHeight: '5.5rem',
  paddingTop: '0.875rem',
  paddingBottom: '0.75rem',
  paddingLeft: '0.5rem',
  paddingRight: '0.5rem',
  borderRadius: '0.875rem',
  border: `1px solid ${$theme.colors.borderOpaque}`,
  backgroundColor: $theme.colors.white,
  color: $theme.colors.contentPrimary,
  textDecoration: 'none',
  textAlign: 'center',
  cursor: 'pointer',
  font: 'inherit',
  boxShadow: $theme.lighting.shadow400,
  transition: 'transform 0.12s, box-shadow 0.12s, border-color 0.12s',
  ':hover': {
    transform: 'translateY(-0.125rem)',
    borderColor: $theme.colors.primary450,
    boxShadow: $theme.lighting.shadow500,
  },
  ':hover > [data-role="tile-icon"]': {
    background: $theme.colors.primary100,
    boxShadow: `0 0 0 0.25rem ${$theme.colors.bg050}`,
  },
  ':active': { transform: 'translateY(0)' },
  ':focus-visible': {
    outline: 'none',
    boxShadow: `0 0 0 0.1875rem ${$theme.colors.accent}`,
    borderColor: $theme.colors.accent,
  },
})

export const TileLink = styled('a', ({ $theme }) => tileStyle($theme))

export const TileButton = styled('button', ({ $theme }) => tileStyle($theme))

export const TileIcon = styled('span', ({ $theme }) => ({
  display: 'grid',
  placeItems: 'center',
  width: '2.5rem',
  height: '2.5rem',
  borderRadius: '999px',
  background: `linear-gradient(135deg, ${$theme.colors.primary100} 0%, ${$theme.colors.bg050} 100%)`,
  color: $theme.colors.primary,
  flexShrink: 0,
  transition: 'background 120ms, box-shadow 120ms',
}))

export const TileLabel = styled('span', {
  fontWeight: 600,
  fontSize: '0.75rem',
  lineHeight: '1rem',
  overflowWrap: 'anywhere',
})
